import Vue from 'vue'
import Vuex from 'vuex'
import appsLogin from './appsLogin' // 登录及用户信息
import teachEvent from './teachEvent' // 教师端 - 实践教学活动
import resourceLibrary from './resourceLibrary' // 教师端 - 实践资源库
import systemManage from './systemManage' // 教师端 - 系统管理
import classesManage from './classesManage' // 教师端 - 活动管理 - 班级管理
import activityStat from './activityStat' // 教师端 - 活动管理 - 实践成绩汇总、实践进度
import cases from './cases' // 教师端 - 实践案例
import train from './train' // 学生端 - 任务模块
import hsjrClass from './hsjrClass' // 教师端 - 实践班级
import stadiumType from './stadiumType' // 教师端 - 场馆类型
import stadiumAddress from './stadiumAddress' // 教师端 - 场馆旧址



//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
  modules: {
    appsLogin,
    train,
    teachEvent,
    resourceLibrary,
    systemManage,
    classesManage,
    activityStat,
    cases,
    hsjrClass,
    stadiumType,
    stadiumAddress
  }
})

export default store